<template>
  <section class="yield-panel advice-panel">
    <div class="yield-title">经营建议</div>
    <div class="advice-list">
      <p v-for="item in adviceList" :key="item.label">
        <b>{{ item.label }}:</b>{{ item.text }}
      </p>
    </div>
  </section>
</template>

<script setup>
const adviceList = [
  { label: "销售", text: "小麦、玉米以订单收购和分批出库为主" },
  { label: "存储", text: "粮食类控制水分入库，花生优先通风防霉" },
  { label: "效益", text: "预计综合收益提升 5.8%–8.4%" },
];
</script>

<style lang="less" scoped>
@import "./YieldLeftShared.less";

.advice-panel {
  padding: 20px 28px 18px;
}

.advice-list {
  margin-top: 28px;
}

p {
  margin: 0 0 14px;
  color: #f5fffd;
  font-size: 26px;
  font-weight: 700;
  line-height: 40px;
  text-align: left;
}

b {
  margin-right: 6px;
  color: #ffffff;
}

p:last-child {
  color: #59fff0;
}
</style>
